export default __webpack_public_path__ + "static/media/Comida.e4830457.png";